<template>
    <div>
        
    </div>
</template>

<script>
export default {
    name: 'ProjectIndex',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>